import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

export const PostalCodeCheckModal = ({ show, handleClose, postalCode, cityInitial, stateProvince }) => {
    return (
        <Modal show={show} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton>Valid Postal Code Info</Modal.Header>
            <Modal.Body>
                <Table>
                    <thead>
                        <tr>
                            <th>Postal Code</th>
                            <th>City Initial</th>
                            <th>State/Province</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{postalCode}</td>
                            <td>{cityInitial}</td>
                            <td>{stateProvince}</td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose} className='purple-btn'>OK</Button>
            </Modal.Footer>
        </Modal>
    )
}